import { List as RAList, ListProps as RAListProps } from "react-admin";
import { styled } from "@mui/material/styles";
import { BORDER_RADIUS } from "@/constants/layout";
import ListSkeletonLoader from "./StyledListSkeletonLoader";

const StyledList = styled(RAList)<RAListProps>(({ theme }) => ({
  padding: theme.spacing(2),

  // Main content card styling
  "& .RaList-content": {
    borderRadius: BORDER_RADIUS.XL,
    boxShadow: theme.shadows[1],
    backgroundColor: theme.palette.background.paper,
  },

  // Remove default margins
  "& .MuiPaper-root": {
    boxShadow: "none",
  },

  // Bulk actions toolbar spacing
  "& .RaBulkActionsToolbar": {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    borderRadius: `${BORDER_RADIUS.XL} ${BORDER_RADIUS.XL} 0 0`,
    padding: theme.spacing(1.5, 2),
  },
}));

interface ListProps extends RAListProps {
  loading?: boolean;
}

export default function List(props: ListProps) {
  const { loading } = props;

  return loading ? <ListSkeletonLoader /> : <StyledList {...props} />;
}
